import React, {useState} from "react";
import useEditableTableTextAreaCell from "../../hooks/useEditableTableTextAreaCell";
import useEditableTableDateCell from "../../hooks/useEditableTableDateCell";
import { Button, Checkbox, Control, Field, Input } from "@allxsmith/bestax-bulma";
import axios from "axios";
import {AsyncTypeahead} from "react-bootstrap-typeahead";
import DriverPicker from "../Settings/Driver/DriverPicker";
import useEditableTableTextCell from "../../hooks/useEditableTableTextCell";
import useEditableTableNumberCell from "../../hooks/useEditableTableNumberCell";
import PrintOptionsModal from "./PrintOptionsModal";
import AdditionalInfoModal from "./AdditionalInfoModal";


export default function ReducedMovementRow({data, index, disabled, onChange, onSave, selected, onSelectCheck, onCheck, endpoint, drivers, onDriverChange, view, quoteToMovement}){
    const [editable, setEditable] = useState(false);
    const [searchData, setSearchData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [typeahead, setTypeahead] = useState();
    const [printOptionsOpen, setPrintOptionsOpen] = useState(false);
    const [additionalInfoOpen, setAdditionalInfoOpen] = useState(false);

    const handleVehicleSearch = query => {
        setLoading(true);
        axios
          .get(endpoint + `vehicles?showAll=true&search=${query}`)
          .then(resp => {
            setSearchData(resp.data.results);
            setLoading(false);
          });
    };

    const getSupplierName = () => {
        // turned into function so actual if statements can be used
        if(data.supplier_status === "EXTERNAL"){
            return data.external_supplier ? data.external_supplier.display_name : ""
        }
        else if(data.supplier_status === "INTERNAL"){
            return data.movement_performer ? data.movement_performer.name : data.department ? data.department.name : ""
        }
        // should never reach this point
        return  "ERROR"
    }

    const getChargeBoxName = () => {
        // follow the same logic as supplier name to figure out if customer charge, internal charge or external supplier charge
        if(data.supplier_status === "EXTERNAL"){
            return "external_supplier_charge"
        }
        else if(data.supplier_status === "INTERNAL"){
            if(data.movement_performer){
                return "internal_charge"
            }
            else {
                return "cost"
            }
        }
    }

    const getCostOverrideBoxName = () => {
        // same as charge box func
        if(data.supplier_status === "EXTERNAL"){
            return "external_supplier_charge_override"
        }
        else if(data.supplier_status === "INTERNAL"){
            if(data.movement_performer){
                return "supplier_cost_override"
            }
            else {
                return "cost_override"
            }
        }
    }

    const onSelect = e => {
        e.stopPropagation();
        onSelectCheck(data);
    };

    const onVehicleUsedChange = e => {
        const toUpdate = {
            target: {
                name:"vehicle_used",
                value: e[0]
            }
        };
        onChange(toUpdate, index);
    };

    const getColor = () => {
        if(data.job){
            return "colored"
        }
        else if(data.rental) {return "table-highlight-orange"}
        else{
            return "table-highlight-dark-red"
        }
    }

    const getTextColour = () => {
        if(getColor() === "table-highlight-dark-red"){
            return "white"
        }
        else{
            return ""
        }
    }

    return (
        <tr className={getColor()} key={data.id}>
            <td className={getTextColour()}>{data.id}</td>
            <td className={getTextColour()}>{getSupplierName()}</td>
            <td className={"wide-column"}>
                {useEditableTableTextCell({
                    propName: "vehicle",
                    value: data.vehicle,
                    onChange: (e) => {
                        e.stopPropagation();
                        onChange(e, index);
                    },
                    editable,
                    setEditable,
                    inlineEdit: !data.completed,
                    disabled: disabled,
                    onSave: () => {
                        onSave(data);
                        setEditable(false);
                    }
                })}
            </td>
            <td>
                {useEditableTableTextAreaCell({
                    propName: "start_address",
                    value: data.start_address,
                    onChange: (e) => {
                        e.stopPropagation();
                        onChange(e, index);
                    },
                    editable,
                    setEditable,
                    inlineEdit: !data.completed,
                    disabled: disabled,
                    onSave: () => {
                        onSave(data);
                        setEditable(false);
                    }
                })}
            </td>
            <td>
                {useEditableTableTextAreaCell({
                    propName: "end_address",
                    value: data.end_address,
                    onChange: (e) => {
                        e.stopPropagation();
                        onChange(e, index);
                    },
                    editable,
                    setEditable,
                    inlineEdit: !data.completed,
                    disabled: disabled,
                    onSave: () => {
                        onSave(data);
                        setEditable(false);
                    }
                })}
            </td>
            <td>
                {useEditableTableDateCell({
                    propName: "delivery_date",
                    value: data.delivery_date,
                    onChange: (e) => {
                        e.stopPropagation();
                        onChange(e, index);
                    },
                    editable,
                    setEditable,
                    inlineEdit: !data.completed,
                    disabled: disabled,
                    onSave: () => {
                        onSave(data);
                        setEditable(false);
                    }
                })}
            </td>
            <td onClick={e => e.stopPropagation()}>
                <Input
                    type={"time"}
                    name={"start_time"}
                    value={data.start_time}
                    disabled={!editable}
                    onChange={(e) => {
                        e.stopPropagation();
                        onChange(e, index);
                    }}
                />
            </td>
            <td onClick={e => e.stopPropagation()}>
                <Input
                    type={"time"}
                    name={"end_time"}
                    value={data.end_time}
                    disabled={!editable}
                    onChange={(e) => {
                        e.stopPropagation();
                        onChange(e, index);
                    }}
                />
            </td>
            {/*<td className={"wide-column"}>*/}
            {/*    {useEditableTableCostCell({*/}
            {/*        propName: getChargeBoxName(),*/}
            {/*        value: data[getChargeBoxName()],*/}
            {/*        onChange: (e) => {*/}
            {/*            e.stopPropagation();*/}
            {/*            onChange(e, index);*/}
            {/*        },*/}
            {/*        editable,*/}
            {/*        setEditable,*/}
            {/*        inlineEdit: !data.completed,*/}
            {/*        disabled: disabled,*/}
            {/*        onSave: () => {*/}
            {/*            onSave(data);*/}
            {/*            setEditable(false);*/}
            {/*        }*/}
            {/*    })}*/}
            {/*</td>*/}
            {/*<td onClick={e => e.stopPropagation()}>*/}
            {/*    <Form.Checkbox*/}
            {/*        checked={data[getCostOverrideBoxName()]}*/}
            {/*        name={getCostOverrideBoxName()}*/}
            {/*        disabled={!editable}*/}
            {/*        onChange={(e) => onCheck(e, index)}*/}
            {/*    />*/}
            {/*</td>*/}
            <td onClick={e => e.stopPropagation()}>
                <AsyncTypeahead
                    useCache={false}
                    isLoading={loading}
                    id="typeahead"
                    labelKey="registration"
                    minLength={2}
                    name={"vehicle_used"}
                    onSearch={handleVehicleSearch}
                    onChange={onVehicleUsedChange}
                    placeholder={`Search Vehicle`}
                    options={searchData}
                    ref={typeahead => setTypeahead(typeahead)}
                    className="typeahead"
                    disabled={!editable || disabled}
                    selected={data.vehicle_used && data.vehicle_used.id ? [data.vehicle_used] : []}
                />
            </td>
            <td>
                {useEditableTableTextAreaCell({
                    propName: "comments",
                    value: data.comments,
                    onChange: (e) => {
                        e.stopPropagation();
                        onChange(e, index);
                    },
                    editable,
                    setEditable,
                    inlineEdit: !data.completed,
                    disabled: disabled,
                    onSave: () => {
                        onSave(data);
                        setEditable(false);
                    }
                })}
            </td>
            <td>
                {useEditableTableTextAreaCell({
                    propName: "supplier_comments",
                    value: data.supplier_comments,
                    onChange: (e) => {
                        e.stopPropagation();
                        onChange(e, index);
                    },
                    editable,
                    setEditable,
                    inlineEdit: !data.completed,
                    disabled: disabled,
                    onSave: () => {
                        onSave(data);
                        setEditable(false);
                    }
                })}
            </td>
            <td onClick={e => e.stopPropagation()}>
                <DriverPicker
                    inlineEdit={!data.completed}
                    onChange={e=> onDriverChange(e, index)}
                    options={drivers}
                    blank={true}
                    disabled={!editable}
                    onSave={() => {
                        onSave(data);
                        setEditable(false);
                    }}
                    editable={editable}
                    setEditable={setEditable}
                    value={data.driver}
                    className={"small-column"}
                />
            </td>
            <td>
                {useEditableTableNumberCell({
                    propName: "driver_sequence_number",
                    value: data.driver_sequence_number,
                    onChange: (e) => {
                        e.stopPropagation();
                        onChange(e, index);
                    },
                    editable,
                    setEditable,
                    inlineEdit: !data.completed,
                    disabled: disabled,
                    onSave: () => {
                        onSave(data);
                        setEditable(false);
                    }
                })}
            </td>
            <td>
                <Checkbox
                    name={"work_complete"}
                    checked={data.work_complete}
                    onChange={(e) => onCheck(e, index)}
                    disabled={!editable}
                />
            </td>
            {(!(data.movement_status === "QUOTE")) ?
                <td onClick={e => e.stopPropagation()} className={"wide-column"}>
                    <Field>
                        <Control className="table-checkbox">
                            <Checkbox
                                checked={selected}
                                type="checkbox"
                                onClick={onSelect}
                                readOnly
                            />
                        </Control>
                    </Field>
                </td> : <td></td>
            }
            <td onClick={e => e.stopPropagation()}>
                <Button
                    color={"warning"}
                    onClick={() => setPrintOptionsOpen(true)}
                >
                    Print
                </Button>
            </td>
            {view === "QUOTE" && data.movement_status === "QUOTE" &&
                <td>
                    <Button
                        onClick={() => quoteToMovement(data)}
                        color={"success"}
                    >
                        Movement
                    </Button>
                </td>
            }
            <td>
                <Button
                    color={"info"}
                    onClick={() => setAdditionalInfoOpen(true)}
                >
                    Info
                </Button>
            </td>
            <td>
                <Button
                    color={"success"}
                    onClick={() => window.open("/editmovement/"+data.id, "_self")}
                >
                    Open
                </Button>
            </td>
            <PrintOptionsModal
                movement={data}
                setOpen={setPrintOptionsOpen}
                open={printOptionsOpen}
            />
            <AdditionalInfoModal
                data={data}
                setShow={setAdditionalInfoOpen}
                show={additionalInfoOpen}
            />
        </tr>
    );

}